import React, { useCallback, useEffect, useState } from 'react';
import { compose, withProps } from 'recompose';
import JoinButton from '../common/JoinButton';
import FadeInContainer from '../common/FadeInContainer';
import { isJoinButtonAvailable } from '../heplers';
import Competitors from './CompetitorsTable';
import DetailsFooter from './DetailsFooter';
import Games from './Games';
import withConditionalLayouts from './withConditionalLayouts';
import { withTranslations } from 'js/components/hocs/withTranslations';
import Media from './Media';
import HeaderBanner from '../common/HeaderBanner';
import withSetNicknameOnce from '../Nickname/withSetNicknameOnce';
import style from './index.scss';
import { getLocationParam } from 'js/utils/url.util';
import { usePortletTranslations } from '../../../system/Portlet';
import { DetailsInnerHeader } from '../common/DetailsInnerHeader';
import { Prizes } from '../common/Prizes';
import { MissionsMain } from '../common/Missions';
import CountDownBadge from '../common/CountDown/CountDownBadge';
import classNames from '../../PassTheParcel/Details/DetailedPage/common/classNames';
import Rules from '../../PassTheParcel/Details/DetailedPage/components/Rules';
import Empty from './CompetitorsTable/Empty';
import { useCommonProperties } from './analytics/useCommonProperties';
import { publicEventsAPIService } from '../../../../services/publicEventsAPI.service';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';
import { equals, pick, prop } from 'ramda';
import { rocket } from '../common/DiscoveryItemWidgetMedia/missionImage';
import { leaderboardImage } from '../common/DiscoveryItemWidgetMedia/leaderboardImage';

let isAlreadyScrolledToBottom = false;

export const DetailsForMobile = (props) => {
    const {
        details,
        displayTable,
        displayGames,
        useTournament
    } = props;
    const { name, rules, leaderboardRules, originalLeaderboardRules } = details;
    const t = usePortletTranslations();
    const { isMobile } = useDeviceSelector(pick(['isMobile']));
    const computeTitle = () => {
        if (!isMissions) {
            return useTournament ? 'competitorsTable.title.tournament' : 'competitorsTable.title';
        }
        return 'competitorsTable.title.missions';
    };
    const isMissions = details.missions;
    const titleKey = computeTitle();
    const leaderboardTab = { titleKey: t(titleKey), name: 'leaderboard',
        analyticsName: titleKey === 'competitorsTable.title.missions' ? 'missions' : 'leaderboard' };
    const prizesTab = { titleKey: t('prizes.title'), name: 'prizes', analyticsName: 'prizes' };
    const rulesTab = { titleKey: t('rules.title'), name: 'rules', analyticsName: 'rules' };
    const paramToTabMapping = {
        leaderboard: leaderboardTab,
        prizes: prizesTab,
        rules: rulesTab
    };
    const toShowPrizes = !isMissions && (details.showEventPrizes || details.showPointsPrizes || details.showRankPrizes);
    const tabs = [leaderboardTab];
    if (toShowPrizes) {
        tabs.push(prizesTab);
    }
    tabs.push(rulesTab);
    const activeTabFromUrl = getLocationParam('activeTab');
    let startTab = tabs.indexOf(paramToTabMapping[activeTabFromUrl]);
    if (startTab === -1) {
        startTab = details.joined ? 0 : tabs.indexOf(rulesTab);
    }
    const [activeTab, setActiveTab] = useState(startTab);
    const [isJoined, setIsJoined] = useState(details.joined);
    const [scrolling, setScrolling] = useState({ scrolling: false, scrollTo: null });
    const hideGamePanel = getLocationParam('hideGamePanel') === '1';

    if (isJoined !== details.joined) {
        setIsJoined(details.joined);
        const tab = details.joined ? 0 : toShowPrizes ? 2 : 1;
        setActiveTab(tab);
    }

    const onHowToPlatClickCallback = () => {
        setActiveTab(toShowPrizes ? 2 : 1);
        window.scrollTo(0, 0);
    };

    const onCompetitorClickedCallback = (e) => {
        if (!details.showRankPrizes) {
            return;
        }
        setScrolling({ scrolling: true, scrollTo: e });
        setActiveTab(1);
    };

    if (props.details.status === 'ACTIVE' && props.details.joined) {
        if (props.details.eventCount) {
            if (props.details.eventCount < props.details.eventCountLimit) {
                props.details.fakeState = 'discoveryActive';
            } else {
                props.details.fakeState = 'discoveryCompleted';
            }
        } else {
            props.details.fakeState = 'discoveryActive';
        }
    } else if (props.details.status === 'ACTIVE' && !props.details.joined) {
        props.details.fakeState = 'discoveryAvailable';
    } else if (props.details.status === 'NOT_STARTED') {
        props.details.fakeState = 'discoveryComingSoon';
    } else if (props.details.status === 'PENDING_REVIEW' || props.details.status === 'COMPLETED' ||
        props.details.status === 'CANCELLED_DUE_TO_NOT_ENOUGH_PARTICIPANTS'
        || props.details.status === 'CANCELLED_BY_ADMIN') {
        props.details.fakeState = 'discoveryFinished';
    }

    const isCancelled = () => {
        return props.details.status === 'CANCELLED_DUE_TO_NOT_ENOUGH_PARTICIPANTS'
        || props.details.status === 'CANCELLED_BY_ADMIN';
    };

    const onTabClicked = (clickedTab) => {
        if (clickedTab !== activeTab) {
            publicEventsAPIService.trigger('player-changes-tab',
                { ...commonProperties, ...{
                        'overlay.engagementId': props.details.leaderboardId,
                        currentTab: tabs[activeTab].analyticsName,
                        newTab: tabs[clickedTab].analyticsName } });
        }
        setScrolling({ scrolling: false, scrollTo: null });
        setActiveTab(clickedTab);
    };

    const defineTextForFinishedEvent = () => {
        if (isMissions) {
            return isCancelled() ? t('campaign.cancelled') : t('campaign.finished');
        }
        return props.details.status === 'PENDING_REVIEW' ?
            t('resultsPending') : t('resultsConfirmed');
    };

    const calculateImageForBanner = () => {
        if (isMissions) {
            return details['detail_page_image'] ? details['detail_page_image'] : !details.bannerUrl ? rocket : details.bannerUrl;
        }
        return details['detail_page_image'] || details.bannerUrl;
    };

    const imageUrl = calculateImageForBanner();

    const competitorsNeedsToBeRendered = props.details.competitorsTable && props.details.competitorsTable.length > 0;
    const emptyStubNeedsToBeRendered = !props.details.competitorsTable || props.details.competitorsTable.length === 0 &&
        props.details.fakeState !== 'discoveryFinished';

    const commonProperties = useCommonProperties();

    const trackScrollToBottom = useCallback(() => {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
            if (!isAlreadyScrolledToBottom) {
                publicEventsAPIService.trigger('player-scrolls-down',
                    { ...commonProperties, ...{ 'overlay.engagementId': props.details.leaderboardId } });
            }
            isAlreadyScrolledToBottom = true;
        }
    }, [commonProperties, props.details.leaderboardId]);

    const trackXButtonClick = () => {
        publicEventsAPIService.trigger('player-clicks-close', { ...commonProperties, ...{
                'overlay.engagementId': props.details.leaderboardId,
                'game.sidebarButton.group': 'Detailed View Page Top',
                'game.sidebarButton.type': 'Close' } });
    };
    const trackBackButtonClick = () => {
        publicEventsAPIService.trigger('player-clicks-backbutton', { ...commonProperties, ...{
                'overlay.engagementId': props.details.leaderboardId,
                'game.sidebarButton.group': 'Detailed View Page Top',
                'game.sidebarButton.type': 'Back' } });
    };
    const trackChangeGameClick = (selectedGameCode, positionInLobby) => {
        publicEventsAPIService.trigger('player-changes-game', { ...commonProperties, ...{
                'overlay.engagementId': props.details.leaderboardId,
                'game.switchMainLaunchAlias': selectedGameCode, positionInLobby } });
    };
    const trackJoinEventClick = () => {
        publicEventsAPIService.trigger('player-clicks-join-lb', { ...commonProperties, ...{
                'overlay.engagementId': props.details.leaderboardId,
                'game.sidebarButton.group': 'Detailed View Page',
                'game.sidebarButton.type': 'leaderboard-opt-in' } });
    };
    const trackLeaveEventClick = () => {
        publicEventsAPIService.trigger('player-clicks-leave-lb', {
            ...commonProperties, ...{
                'overlay.engagementId': props.details.leaderboardId,
                'game.sidebarButton.group': 'Detailed View Page',
                'game.sidebarButton.type': 'leaderboard-opt-out'
            }
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', trackScrollToBottom, false);
        return () => {
            window.removeEventListener('scroll', trackScrollToBottom, false);
        };
    }, [trackScrollToBottom]);

    const isAllRulesHaveNoGamingContext = (rulesInfo) => {
        const noGamingContextArray = rulesInfo.map((rule) => {
            return rule.gameRoundRuleInfo.gamingContextType === 'NO_GAMING_CONTEXT';
        });
        return !noGamingContextArray.includes(false);
    };

    const handleMobileView = () => {
        const smallerEdge = Math.min(window.innerHeight, window.innerWidth);
        if (smallerEdge >= 400) {
            return style.dataWrapperLarge;
        } else if (smallerEdge > 360) {
            return style.dataWrapperMedium;
        }
        return style.dataWrapperSmall;
    };

    const getGamesFromRules = () => {
        const games = [];
        if (leaderboardRules.length > 0) {
            leaderboardRules.forEach((gamesRule) => {
                const gamesFormRule = gamesRule && gamesRule.gameRoundRuleInfo && gamesRule.gameRoundRuleInfo.games;
                if (gamesFormRule) {
                    gamesFormRule.forEach((gameFormLoop) => {
                        games.push({
                            gameCode: gameFormLoop,
                            isNotStarted: Boolean(gamesRule.millisecondsTillRuleStart),
                            isFinished: Boolean(!gamesRule.millisecondsTillRuleStart
                                && !gamesRule.millisecondsTillRuleEnd),
                            isActive: Boolean(gamesRule.millisecondsTillRuleEnd > 0
                                && !gamesRule.millisecondsTillRuleStart),
                            timeToStart: gamesRule.millisecondsTillRuleStart
                            && gamesRule.millisecondsTillRuleStart > 0 ? gamesRule.millisecondsTillRuleStart : 0
                        });
                    });
                }
            });
        }
        return games;
    };

    let gamesSupportedByPortal = useAppSelector(prop('games'));
    // gamesSupportedByPortal could came null.
    if (gamesSupportedByPortal == null) {
        gamesSupportedByPortal = [];
    }

    const getAvailableGamesSupportedByPortal = () => {
        const gamesFromRules = getGamesFromRules();
        const availableGames = gamesFromRules.filter(gameInfo => gamesSupportedByPortal[gameInfo.gameCode]);
        const isEqual = equals(availableGames, gamesFromRules);
        return isEqual ? gamesFromRules : availableGames;
    };

    const gamesArePresent = () => {
        const games = getAvailableGamesSupportedByPortal();
        return games && games.length > 0;
    };

    const widgetType = () => props.details.missions ? 'missions' : 'lb';
    return (
        <FadeInContainer className={classNames(style.direction, style.container, { [style.mainWrapper]: !isMobile,
            [handleMobileView()]: isMobile })}>
            <div className={style.section}>
                <div className={style.contentWrapper}>
                    <div className={style.detailsTabs}>
                        <DetailsInnerHeader initialActiveTabIndex={activeTab} tabs={tabs}
                                            onActiveTabClick={onTabClicked}/>
                    </div>
                    <div className={isJoinButtonAvailable(details) ? style.bannerWrapper : style.bannerWrapperCollapsed}>
                        <Media imageUrl={imageUrl || leaderboardImage} visible={true} translatedState={t(props.details.fakeState)}
                               fakeState={props.details.fakeState} isMissions={isMissions} eventCount={props.details.eventCount}
                               eventCountLimit={props.details.eventCountLimit} />
                        {props.details.fakeState !== 'discoveryFinished' && props.details.registrationStatus !== 'FINISHED' &&
                        <CountDownBadge className={style.countDownBadge}
                                        status={props.details.status}
                                        endTime={props.details.leaderboardEndTime}
                                        startTime={props.details.leaderboardStartTime}
                                        importedStyle={style}
                        />}
                        {props.details.fakeState === 'discoveryFinished' &&
                        <div className={style.resultsConfirmedBadge}>{defineTextForFinishedEvent()}</div>}
                        {!props.details.joined && props.details.fakeState !== 'discoveryFinished' &&
                        props.details.registrationStatus === 'FINISHED' &&
                        <div className={style.resultsConfirmedBadge}>{t('registrationClosed')}</div>}
                    </div>
                    {isJoinButtonAvailable(details)
                    && <JoinButton {...details} wide={true} {...props} fakeState={props.details.fakeState}
                                   trackJoinEventClick={trackJoinEventClick} />
                    }
                    {activeTab === 0 && !isMissions && competitorsNeedsToBeRendered && (
                        <Competitors
                            className={style.competitors}
                            displayTitle={false}
                            onCompetitorClicked={onCompetitorClickedCallback}
                            displayTable={displayTable}
                            useRoundsTitle={props.useRounds}
                            showPrizes={false}
                            useTournament={useTournament}
                            {...details}
                        />
                    )}{activeTab === 0 && !isMissions && emptyStubNeedsToBeRendered && (
                        <Empty />
                    )}{activeTab === 0 && isMissions && (
                        <div className={style.prizesMainStyle}><MissionsMain originalLeaderboardRules={originalLeaderboardRules}
                                                                             {...details}/></div>
                    )}
                    {activeTab === 1 && toShowPrizes && <div className={style.prizesMainStyle}><Prizes
                        showEventPrizes={props.details.showEventPrizes}
                        showPointsPrizes={props.details.showPointsPrizes}
                        showRankPrizes={props.details.showRankPrizes}
                        eventBasedPrizes={props.details.eventBasedPrizes}
                        pointBasedPrizes={props.details.pointBasedPrizes}
                        prizes={props.details.prizes}
                        useRounds={props.useRounds}
                        scrollTo = {scrolling}
                    /></div>}
                    {(!toShowPrizes && activeTab === 1 || toShowPrizes && activeTab === 2) && <div>
                        <div className={style.titleBlock}>
                            <span className={classNames(style.titleText)}>{t('rules.title')}</span>
                        </div>
                        <div className={style.block}>
                            <Rules classname={style.customRules} textRules={rules} />
                        </div>
                    </div>}
                    {!isMissions && displayGames && !hideGamePanel && !isAllRulesHaveNoGamingContext(leaderboardRules) &&
                    gamesArePresent() && <>
                        <div className={style.titleBlock}>
                            <span className={style.titleText}>{t('gamesSection.title')}</span>
                        </div>
                         <Games games={getAvailableGamesSupportedByPortal()} trackChangeGameClick={trackChangeGameClick}/>
                    </>
                    }
                    <DetailsFooter className={style.footer} activePage={activeTab} wide={true} {...details}
                                   {...props} onHowToPlayCallback={onHowToPlatClickCallback} toShowPrizes={toShowPrizes}
                                   trackLeaveEventClick={trackLeaveEventClick} activeTab={activeTab}/>
                </div>
                <HeaderBanner
                    {...details}
                    text={name}
                    useBackButton={props.showBackButton}
                    backButtonUrl={props.backButtonUrl}
                    className={style.mainHeaderStyle}
                    trackXButtonClick={trackXButtonClick}
                    trackBackButtonClick={trackBackButtonClick}
                    widgetType={widgetType()}
                />
            </div>
        </FadeInContainer>
    );
};

export default compose(
    withConditionalLayouts,
    withTranslations,
    withProps(() => {
        const [joinAttempted, setJoinAttempted] = useState(false);
        return {
            displaySetNickname: joinAttempted,
            setJoinAttempted
        };
    }),
    withSetNicknameOnce
)(DetailsForMobile);
